"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "salsomaggiore-terme": {
    "2eaaac6d": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "skipSearch": false
    }],
    "banzola": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a13cfbc2": [{
      "hkey": "31f84c80",
      "slug": "ceriati-costa",
      "name": "Ceriati-Costa",
      "primary": true,
      "skipSearch": false
    }],
    "cangelasio-ceriati": [{
      "hkey": "31f84c80",
      "slug": "ceriati-costa",
      "name": "Ceriati-Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "971f20b6": [{
      "hkey": "1c9aec92",
      "slug": "contignaco",
      "name": "Contignaco",
      "primary": true,
      "skipSearch": false
    }],
    "contignaco-nuclei-abitati-pie-di-via": [{
      "hkey": "1c9aec92",
      "slug": "contignaco",
      "name": "Contignaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fb234d32": [{
      "hkey": "31f84c80",
      "slug": "ceriati-costa",
      "name": "Ceriati-Costa",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "31f84c80",
      "slug": "ceriati-costa",
      "name": "Ceriati-Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "salsomaggiore-terme"
    }],
    "f96e8406": [{
      "hkey": "0507f88e",
      "slug": "rossi",
      "name": "Rossi",
      "primary": true,
      "skipSearch": false
    }],
    "marzano-nuclei-abitati-rossi": [{
      "hkey": "0507f88e",
      "slug": "rossi",
      "name": "Rossi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8e3959c7": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "skipSearch": false
    }],
    "montebello": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c965b817": [{
      "hkey": "970e1784",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "salsomaggiore-terme": [{
      "hkey": "970e1784",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "52cb9fd9": [{
      "hkey": "facef109",
      "slug": "salsominore",
      "name": "Salsominore",
      "primary": true,
      "skipSearch": false
    }],
    "salsomainore": [{
      "hkey": "facef109",
      "slug": "salsominore",
      "name": "Salsominore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50487d0a": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "skipSearch": false
    }],
    "sivizzano": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a78d6ee": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "skipSearch": false
    }],
    "stivalini": [{
      "hkey": "e61d18ad",
      "slug": "salsomaggiore-terme",
      "name": "Salsomaggiore Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39e03e5b": [{
      "hkey": "0694f7f1",
      "slug": "bagni-di-tabiano",
      "name": "Bagni di Tabiano",
      "primary": true,
      "skipSearch": false
    }],
    "tabiano-nuclei-abitati-bagni-di-tabiano": [{
      "hkey": "0694f7f1",
      "slug": "bagni-di-tabiano",
      "name": "Bagni di Tabiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;